import { ReferralTemplate } from '@recruitee/http/types';
import { createEntityCollectionStore, pipeState } from '@recruitee/ngrx';

import { EntityStoreKey } from '../types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<ReferralTemplate>()(
  EntityStoreKey.questionsTemplates,
  {
    customActions: adapter => ({
      fetchOneSuccess: (state, { data, scope }: { data: ReferralTemplate; scope?: any }) =>
        pipeState(
          state,
          next =>
            adapter.markAsLoaded(next, {
              entities: [],
              scope: scope || 'main',
            }),
          next =>
            adapter.addOne(next, data, {
              scope: scope || 'main',
            }),
        ),
    }),
  },
);

export {
  actions as QuestionsTemplatesActions,
  reducer as questionsTemplatesReducer,
  selectors as questionsTemplatesSelectors,
  namespace as QuestionsTemplatesNamespace,
};
